import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';

const LineDryClothing = ({
  t,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('In addition to the direct energy saving benefits, planting trees can increase natural beauty of city landscapes, reduce pollution, cool outside temperatures, as well as provide wood, fruit and other beneficial products.')}
      </p>
      <p>
        {t('I will plant')}
        <InlineInput
          maxLength={4}
          apiKey={'input_takeaction_plant_trees_amount'}
        />
        {t('trees. Each tree will cost')}
        <InlineInput
          currency
          maxLength={6}
          apiKey="input_takeaction_plant_trees_cost"
        />
      </p>
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('Each year, you save $10 for every tree planted.')}
        </li>
        <li>
          {t('A large portion of your savings come from reduced AC use as a result of increased shading and a reduction in outside temperature. Trees also reduce heating by lowering wind speed.')}
        </li>
      </ul>
    </div>
  </div>
);

LineDryClothing.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => []
.reduce((props, apiKey) => ({
  ...props,
  [apiKey]: s.results(apiKey)(state, ownProps),
}), {});

const mapDispatchToProps = (_dispatch, _ownProps) => ({});

export default wrap(
  withT('plantTrees'),
  connect(mapStateToProps, mapDispatchToProps)(LineDryClothing),
);
